<template>
  <section class="customers-read-resume-state">
    <former-error
      v-if="message"
      class="customers-read-resume-alert"
    >
      {{ message }}
    </former-error>

    <div class="customers-read-resume-states">
      <former-button
        v-for="button in buttons"
        :key="button.value"
        class="customers-read-resume-states-button"
        :color="button.color"
        :read-only="changing === button.id"
        @click="change(button.value)"
      >
        {{ button.label }}
      </former-button>

      <span
        v-if="!isCustomerProfile"
        class="customers-read-resume-states-profile"
      >
        <former-button
          key="customer-profile"
          class="customers-read-resume-states-button"
          color="gray"
          size="small"
          :href="customerProfile"
        >
          Ir para a página do cliente
        </former-button>
      </span>
    </div>

    <popup-confirm
      v-if="popup"
      title="Status"

      :loading="loading"

      @close="toggle(true)"
      @confirm="submit"
    >
      Alterar o status do cliente para <b>{{ prettified }}</b>?
    </popup-confirm>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import PopupConfirm from '@/components/Popup/Confirm.vue';

  import FormerButton from '@/components/Former/Button.vue';
  import FormerError from '@/components/Former/Error.vue';

  export default {
    name: 'CustomersReadResumeState',
    components: {
      FormerButton,
      FormerError,
      PopupConfirm,
    },
    data() {
      return {
        popup: false,
        changing: null,
      };
    },
    computed: {
      ...mapState([
        'customers',
      ]),

      buttons() {
        return [{
          id: 'checagem',
          value: 'reset_status',
          label: 'Checagem',
          color: (!this.changing || this.changing === 'checagem') ? 'blue' : 'gray',
        }, {
          id: 'valido',
          value: 'validate',
          label: 'Válido',
          color: this.changing === 'valido' ? 'green' : 'gray',
        }, {
          id: 'inválido',
          value: 'invalidate',
          label: 'Inválido',
          color: this.changing === 'inválido' ? 'red' : 'gray',
        }];
      },
      loading() {
        return this.customers.read.loading;
      },
      customer() {
        return this.customers.read.item;
      },
      message() {
        if (!this.changing || this.changing === 'checagem') {
          return `As informações deste cliente ainda não foram checadas e validadas.
                  Realize esta operação antes de prosseguir.`;
        }

        if (this.changing === 'inválido') {
          return `As informações deste cliente foram consideradas inválidas.
                  Verifique novamente o cadastro se deseja prosseguir.`;
        }

        return false;
      },
      prettified() {
        const buttonPrettified = this.buttons.find(button => button.value === this.changing);
        return buttonPrettified ? buttonPrettified.label : '';
      },

      isCustomerProfile() {
        return this.$route.name === 'customers-read-informations';
      },
      customerProfile() {
        return {
          name: 'customers-read-informations',
          params: {
            id: this.customer.id,
          },
        };
      },
    },
    mounted() {
      this.update();
    },
    methods: {
      toggle(force = false) {
        this.popup = !this.popup;

        if (force) {
          this.reset();
        }
      },
      update(state = null) {
        this.changing = state || this.customer.state;
      },
      reset() {
        this.changing = this.customer.state;
      },
      change(state) {
        this.toggle();
        this.update(state);
      },

      submit() {
        this.$store
          .dispatch('customers/status', {
            id: this.customer.id,
            status: this.changing,
          })
          .then(this.toggle)
          .catch(this.submitFailure);
      },
      submitSuccess() {
      },
      submitFailure() {
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .customers-read-resume-state {
    margin: $gutter-small 0 $gutter-bigger;
  }

  .customers-read-resume-states {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    @media all and (min-width: $breakpoint-desktop) {
      justify-content: flex-start;
      margin: 0 (-$gutter-small);
    }
  }

  .customers-read-resume-states-button {
    & + & {
      margin-left: $gutter-smaller;
    }
  }

  .customers-read-resume-states-profile {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: center;
    margin-top: $gutter;
    min-width: 100%;

    @media all and (min-width: $breakpoint-desktop) {
      justify-content: flex-end;
      min-width: 0;
    }
  }

  .customers-read-resume-alert {
    margin: 0 (-$gutter) $gutter;

    @media all and (min-width: $breakpoint-desktop) {
      margin-left: -$gutter-biggest;
      margin-right: -$gutter-biggest;
      padding-left: $gutter-biggest;
      padding-right: $gutter-biggest;
    }
  }
</style>
